<template>
  <div>
    <van-nav-bar title="消息中心" />
    <div class="list-content" id="list-content">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad">
          <van-cell-group>
            <van-swipe-cell   v-for="item in myList"
                              :key="item.id"
                              size="large">
              <template #left>
                <van-button square type="primary" text="查看明细"   @click="getMessageDetails(item.id, item)" />
              </template>
              <van-cell :border="false"   :title="item.title"  :label="item.msgcontent"  @click="getMessageDetails(item.id,item)" />
              <template #right>
                <van-button square type="danger" @click="deleteMessageById(item.id)" color="#" text="删除" />
              </template>
            </van-swipe-cell>
          </van-cell-group>
        </van-list>

      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import {Badge, Card, Cell, CellGroup, List, SwipeCell, Toast} from "vant";

export default {
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    [Badge.name]: Badge,
    [SwipeCell.name]: SwipeCell,
    [Card.name]: Card
  },
  data() {
    return {
      page: 1,
      loading: false, // 当loading为true时，转圈圈
      finished: false, // 数据是否请求结束，结束会先显示- 没有更多了 -
      myList:[],
      noData: false, // 如果没有数据，显示暂无数据
      isLoading:false, // 下拉的加载图案
      fphm:'',
      totalPages:0
    };
  },
  mounted(){
    let winHeight = document.documentElement.clientHeight;                    //视口大小
    document.getElementById('list-content').style.height = (winHeight - 10) +'px'  //调整上拉加载框高度
  },
  methods: {
    deleteMessageById(id) {   //查看明细
      var url = "/memberBusiness/information/delete/"+id;
      this.$axios.post(url).then((data) => {
        if(data.code==200){
          this.onRefresh();
        }else{
        }
      });
    },
    getMessageDetails(id, item) {   //查看明细
      var url = "/memberBusiness/information/updateInformation";
      this.$axios.post(url, item).then((res) => {
        this.$router.push({ path: "messageContent", query: { Uid: id } });
      });
    },
    getInfo() {
      let _this = this;
      let url = "/memberBusiness/information/"+this.page+"/10/informationList";
      return new Promise((resolve, reject) => {
        _this.$axios
            .get(url)
            .then(data => {
              if(data.code==200){

                this.loading = false;
                this.myList = this.myList.concat(data.data.content)
                this.page++
                // 如果没有数据，显示暂无数据
                if (this.myList.length === 0 && this.page === 1) {
                  this.noData = true
                }
                // 如果加载完毕，显示没有更多了
                if (this.page ===data.data.totalPages ) {
                  this.finished = true;
                }
              }else{
                this.finished = true
                this.loading=false;
                this.isLoading=false;
              }
            })
            .catch(erro => {
              reject(erro);
            });
      });
    },
    onLoad () {   // 上拉
      setTimeout(() => {
        this.getInfo()
        this.loading = true
      }, 500)
    },
    onRefresh () {  //下拉刷新
      setTimeout(() => {
        this.isLoading = false
        this.myList = []
        this.page = 1
        this.loading = false
        this.finished = false
        this.noData = false
        // 请求信息
        this.getInfo()
      }, 500)
    }

  },
};
</script>

<style >
.goods-card {
  margin: 0;
  background-color: white;
}

.delete-button {
  height: 100%;
}


</style>
